import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class InformeService {

  myAppUrl: string = "";

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getInforme1() {
    let url = `${this.myAppUrl}api/Informe/GetInforme1`;
    this.downloadFromApiGet(url, "application/octet-stream", "IP1.xlsx")
    // return this._http.get(`${this.myAppUrl}api/Informe/generarInforme1`)
  }

  getInforme2() {
    let url = `${this.myAppUrl}api/Informe/GetInforme2`;
    this.downloadFromApiGet(url, "application/octet-stream", "IP2.xlsx")
    // return this._http.get(`${this.myAppUrl}api/Informe/generarInforme2`)
  }

  getInforme3() {
    let url = `${this.myAppUrl}api/Informe/GetInforme3`;
    this.downloadFromApiGet(url, "application/octet-stream", "IP3.xlsx")
  }

  getInforme4(date: any = '', dateEnd: any = '') {
    let params = new HttpParams()
    .set('date', date)
    .set('dateEnd', dateEnd)
    let url = `${this.myAppUrl}api/Informe/GetInforme4?${params.toString()}`;
    this.downloadFromApiGet(url, "application/octet-stream", "IP4.xlsx")
  }

  getInforme5(date: any = '', dateEnd: any = '') {
    let params = new HttpParams()
    .set('date', date)
    .set('dateEnd', dateEnd)
    let url = `${this.myAppUrl}api/Informe/GetInforme5?${params.toString()}`;
    this.downloadFromApiGet(url, "application/octet-stream", "IP5.xlsx")
  }

  getInformePrescriptores(prescriptorId: any = '') {
    let params = new HttpParams()
    .set('prescriptorId', prescriptorId);

    let url = `${this.myAppUrl}api/Informe/GetInformePrescriptores?${params.toString()}`;
    this.downloadFromApiGet(url, "application/octet-stream", "ListadoPrescriptores.xlsx")
  }

  public downloadFromApiGet(url: string, mimeType: string, fileName: string) {
    this._http.get(url, { responseType: 'blob' }).subscribe(
      (blobData: Blob) => {
        const blob = new Blob([blobData]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href); // Liberar recursos
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }

}
